import type { AccountPreferences } from "@keystone-ui/types";
import type { SSData } from "@keystone-ui/types";

import { CONFIG } from "config";
import { secondsAgo } from "utils";

type LastShownOptions = {
  maxAllowedPrompts: number;
  optInWaitSeconds: number;
};

export type MarketingEligibleConfig = {
  isMarketingEligible: boolean;
  reminderCount: number;
};

export function marketingEligible(
  { data }: { data: SSData },
  MAX_ALLOWED_PROMPTS?: number | undefined,
): MarketingEligibleConfig {
  const { user, uiEvents } = data;
  const marketingPreference = user?.accountPreferences.find(
    (pref) => pref.preferenceName === "marketing-optin",
  );
  const marketingEvent = uiEvents?.events?.["marketingOptInPresented"];
  const isMarketingEligible = marketingEligibleConfig(
    marketingPreference,
    marketingEvent,
    {
      maxAllowedPrompts: MAX_ALLOWED_PROMPTS ?? 3,
      optInWaitSeconds: CONFIG.OPT_IN_WAIT_SEC,
    },
  );

  const reminderCount = marketingEvent?.["count"] ?? 0;

  const marketingOptInConfig: MarketingEligibleConfig = {
    isMarketingEligible,
    reminderCount,
  };

  return marketingOptInConfig;
}

export function marketingEligibleConfig(
  marketingPreference?: AccountPreferences,
  marketingEvent?:
    | string
    | number
    | boolean
    | Record<string, string | number | boolean>,
  lastShownOptions?: LastShownOptions,
): boolean {
  if (marketingPreference?.preferenceValue) {
    return false;
  }
  if (lastShownOptions && marketingEvent?.["presentedAt"]) {
    const lastShown = new Date(marketingEvent?.["presentedAt"]);
    const numSecondsAgo = secondsAgo(lastShown);
    const shownCount = marketingEvent?.["count"] ?? 0;
    return (
      shownCount < lastShownOptions.maxAllowedPrompts &&
      numSecondsAgo >= lastShownOptions.optInWaitSeconds
    );
  }
  return true;
}
